import { useQuery } from '@tanstack/react-query'
import { getMatters } from '@/lib/api-client'
import { isAuthenticated } from '@/lib/storage'
import type { Matter } from '@/types'

export function useMatters(search: string) {
  return useQuery<Matter[], { message: string; status: number }>({
    queryKey: ['matters', search],
    enabled: isAuthenticated(),
    queryFn: async () => {
      const params: Record<string, string> = { limit: '20' }
      if (search.trim()) params['search'] = search.trim()
      const result = await getMatters(params)
      if (result.error) {
        throw { message: result.error, status: result.status }
      }
      return result.data!.data
    },
    staleTime: 30_000,
    gcTime: 60_000,
  })
}
